// src/app/%28full-width-pages%29/%28auth%29/signin/page.tsx
import { createFileRoute } from '@tanstack/react-router'
import SignInForm from "@/components/auth/SignInForm";
import type { Metadata } from "next";

export const metadata: Metadata = {
  title: "Next.js SignIn Page | TailAdmin - Next.js Dashboard Template",
  description: "This is Next.js Signin Page TailAdmin Dashboard Template",
};

function SignIn() {
  return <SignInForm />;
}

export const Route = createFileRoute('/(authentication)/(auth)/signin/')({
  component: SignIn,
})
